/**
 * Replaces Next.js polyfill-module for modern browsers.
 * Keeps URL.canParse for Safari 16.4 (Next.js minimum supported Safari).
 */
if (typeof URL !== 'undefined' && !('canParse' in URL)) {
  URL.canParse = function (url, base) {
    try {
      return !!new URL(url, base);
    } catch {
      return false;
    }
  };
}
